<card
    [changeModeFn]="changeModeFn"
    [showEditSaveButton]="showEditSaveButton$ | async"
    [title]="'Payment Information'"
    [(mode)]="linkedMode"
    (save)="save()"
>
    <card-view-mode-content>
        <div class="flex flex-col gap-medpace">
            <div>
                What are you requesting?
                <span class="required-asterisk">*</span>
            </div>
            <div>
                <mds-radio-group
                    [buttons]="reimbursementType_RadioButtons"
                    [formCtrl]="formGrp().controls.type"
                    id="requestType"
                />
            </div>
            <div>
                @if (reimbursementRequest(); as reimbursementRequest) {
                    <medpace-reimbursement-request-view [request]="reimbursementRequest" />
                }
                @if (stipendRequest(); as stipendRequest) {
                    <medpace-stipend-request-view [request]="stipendRequest" />
                }
            </div>
        </div>
    </card-view-mode-content>
    <card-edit-mode-content>
        <div class="flex flex-col gap-medpace">
            <div>
                What are you requesting?
                <span class="required-asterisk">*</span>
            </div>
            <div>
                <mds-radio-group
                    [buttons]="reimbursementType_RadioButtons"
                    [formCtrl]="formGrp().controls.type"
                    id="requestType"
                />
            </div>
            @let type = type$ | async;
            <div>
                @if (type === 'out-of-pocket') {
                    <medpace-reimbursement-request-edit
                        [formGrp]="formGrp().controls.reimbursement"
                        [request]="reimbursementRequest$ | async"
                    />
                } @else if (type === 'stipend') {
                    <medpace-stipend-request-edit
                        [formGrp]="formGrp().controls.stipend"
                        [request]="stipendRequest$ | async"
                    />
                }
            </div>
        </div>
    </card-edit-mode-content>
</card>
